var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnavailable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3503 33.0083L33.8503 33.0083L33.8503 32.5083L33.8503 5.76904C33.8503 3.28376 31.8356 1.26904 29.3503 1.26904L8.97559 1.26904C6.4903 1.26904 4.47559 3.28377 4.47559 5.76905L4.47558 32.5083L4.47558 33.0083L4.97558 33.0083L33.3503 33.0083Z",
    fill: "#D1D1D1",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.28613 21.3716C2.28613 19.6682 3.66698 18.2874 5.37034 18.2874C7.0737 18.2874 8.45455 19.6682 8.45455 21.3716L8.45455 36.9982L6.28613 36.9982C4.07699 36.9982 2.28613 35.2074 2.28613 32.9982L2.28613 21.3716Z",
    fill: "#D1D1D1",
    stroke: "white",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3564 19.947C31.3564 18.2436 32.7373 16.8628 34.4407 16.8628C36.144 16.8628 37.5249 18.2436 37.5249 19.947L37.5249 31.5737C37.5249 33.7828 35.734 35.5737 33.5249 35.5737L31.3564 35.5737L31.3564 19.947Z",
    fill: "#D1D1D1",
    stroke: "white",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2842 31.5453L38.2842 35.8315C38.2842 38.0407 36.4933 39.8315 34.2842 39.8315L5.82471 39.8315C3.61557 39.8315 1.82471 38.0407 1.82471 35.8315L1.82471 31.5453L38.2842 31.5453Z",
    fill: "#D1D1D1",
    stroke: "white",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnavailable);
export default __webpack_public_path__ + "static/media/unavailable.8557722bc40ef71f1a88f2e56f6bd156.svg";
export { ForwardRef as ReactComponent };